import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import * as DocumentsActions from '../actions/documents.actions';
import { MessageService } from 'primeng/api';

@Injectable()
export class DocumentsEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private messageService = inject(MessageService);

  //   Get File Content
  getFileContentDocumentsItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.getFileContentDocuments),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.id;

          return this.baseService[apiConstants?.method](apiConstants, {
            responseType: 'text'
          }).subscribe((documentContent: any) => {
            this.store.dispatch(
              DocumentsActions.setFileContentDocuments({
                sid: action.sid,
                documentContent: documentContent,
                loader: false
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getAttachmentContent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.getAttachmentContent),
        map((action: any) => {
          const apiConstants = { ...action.attachmentApiConstants };
          apiConstants.url = action.attachmentApiConstants.url + action.id;

          return this.baseService[apiConstants?.method](apiConstants, {
            responseType: 'text'
          }).subscribe((documentContent: any) => {
            this.store.dispatch(
              DocumentsActions.setFileContentDocuments({
                sid: action.sid,
                documentContent: documentContent,
                loader: false
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getSidBasedDocument$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.getSidBasedDocument),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.sid;

          return this.baseService[apiConstants?.method](apiConstants).subscribe((sidDocumentData: any) => {
            this.store.dispatch(
              DocumentsActions.setSidBasedDocument({
                sidDocumentData: { ...sidDocumentData }
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  //   Sent File Attachment
  saveFileAttachmentDocumentsItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.sentFileAttachmentDocuments),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](
            action.apiConstants,
            action.documentAttachment
          ).subscribe((response: any) => {
            console.log(response);
          });
        })
      ),
    {
      dispatch: false
    }
  );

  //   Save File Content Document Data
  saveFileContentDocumentsItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.sentFileContentDocuments),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.sid;

          return this.baseService[apiConstants?.method](apiConstants, action.documentContent).subscribe(
            (response: any) => {
              const documentData = {
                appId: response.appId,
                orgId: response.orgId,
                attachments: action.attachments,
                status: action.status,
                contentAttachment: response.contentAttachment,
                description: response.description,
                sid: response.sid
              };
              this.store.dispatch(
                DocumentsActions.sentDocuments({
                  saveDocumentsData: documentData,
                  apiConstants: ApiConstants.updateDocument,
                  method: action.method
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  deleteAttachments$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.deleteAttachments),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.sid;

          return this.baseService[apiConstants?.method](apiConstants).subscribe((response: any) => {
            this.store.dispatch(
              DocumentsActions.setSidBasedDocument({
                sidDocumentData: { ...response }
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  // Get Documents Data
  getDocumentsItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.getDocuments),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, {
            start: action.first,
            length: action.rows,
            order: [
              {
                column: 'createdDate',
                dir: 'desc'
              }
            ]
          }).subscribe((documentsData) => {
            this.store.dispatch(
              DocumentsActions.setDocuments({
                documentsData: documentsData.results,
                totalRecords: documentsData.total || 0
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getDocumentsItemsWithSorting$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.getDocumentsWithSorting),
        map((action: any) => {
          const filters = {
            start: action.first,
            length: action.rows,
            order: [
              {
                column: action.sortField,
                dir: action.sortOrder
              }
            ]
          };
          return this.baseService[action.apiConstants?.method](action.apiConstants, filters).subscribe(
            (documentsData) => {
              this.store.dispatch(
                DocumentsActions.setDocumentsWithSorting({
                  documentsData: documentsData.results,
                  totalRecords: documentsData.total || 0
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  srcText: string | null = null;
  // Get Documents Data Search
  getDocumentsBasedOnSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.getDocumentsBasedOnSearch),
        map((action: any) => {
          const searchQuery = {
            start: action.first,
            length: action.rows,
            search: action.searchFields,
            order: [
              {
                column: 'createdDate',
                dir: 'desc'
              }
            ]
          };
          return this.baseService[action.apiConstants?.method](
            action.apiConstants,
            JSON.stringify(searchQuery)
          ).subscribe((documentsData: any) => {
            this.srcText = '';
            this.store.dispatch(
              DocumentsActions.setDocuments({
                documentsData: documentsData.results,
                totalRecords: documentsData.total || 0
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  // Save Document Data
  saveDocumentItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.sentDocuments),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.saveDocumentsData).subscribe(
            (response: any) => {
              if (action.method === 'save') {
                this.store.dispatch(
                  DocumentsActions.saveDocuments({
                    saveDocumentsData: response
                  })
                );
                this.showMessage('success', 'Document saved successfully');
              } else {
                this.store.dispatch(
                  DocumentsActions.updateDocuments({
                    updateDocumentsData: response
                  })
                );
                // this.showMessage('success','Document updated successfully');
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  // Delete Documents Data
  deleteDocumentItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentsActions.sentDeleteDocuments),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.documentsId;

          return this.baseService[action.apiConstants?.method](apiConstants).subscribe((menuData: any) => {
            this.showMessage('success', 'Document Deleted Successfully !');
            return this.store.dispatch(
              DocumentsActions.deleteDocuments({
                documentsId: action.documentsId
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }
}
